export default {
    getBlockchain: (state) => state.blockchain,
    getBlockchainUserSelected: (state) => state.blockchainUserSelected,
    getBlockchainError: (state) => state.blockchainError,
    getBlockchainInput: (state) => state.blockchainInput,
    getBlockchainInfo: (state) => state.blockchainInfo,
    getBlockchainResponse: (state) => state.blockchainResponse,
    getBlockchainDropdown: (state) => state.blockchainDropdown,
    getBlockchainDropdownState: (state) => Object.values(state.blockchainDropdown).some(flag => flag),
    getIsResponseHasEssential: (state) => Object.values(state.blockchainResponse).some(item => item.essential === true),
    getIsResponseHasAdvanced: (state) => Object.values(state.blockchainResponse).some(item => item.essential !== true),
    anyLoaded: (state) => {
        const values = Object.values(state.blockchainResponse)
        return values.some(item => item.loading === false)
    },
    allLoaded: (state) => {
        const values = Object.values(state.blockchainResponse)
        return values.length === 0 || values.every(item => item.loading === false)
    },
    getBlockchainRequestsOpen: (state) => state.blockchainRequestsOpen,
    getSomeHasExtendedFeatures: (state) => {
        return Object.values(state.blockchainResponse || {}).some(item =>
            item.hasAlerts || item.hasCases || item.hasReports || item.isMonitoring
        )
    },
    getBlockchainRecentQueriesState: (state) => state.blockchainRecentQueriesState,
    getBlockchainMultiSelectState: (state) => state.blockchainMultiSelectState,
}
